/* The leftover plan, as both prompts draw it. A sunken well inside the card surface, so it reads as
 * the THING the question is about rather than as another line of the question. Neutral throughout:
 * the accent on these prompts belongs to the one answer that continues the work. */

.card {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  padding: var(--space-3);
  text-align: left;
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

/* Sized in CSS before the image arrives, so a slow cover changes ink and never the card's height. */
.cover {
  display: block;
  flex: none;
  width: 64px;
  height: 64px;
  object-fit: cover;
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-sm);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

/* A name runs to 200 characters. Two lines, then an ellipsis — the figures under it are what tell
 * two plans apart once the names agree that far. `anywhere`, because a pasted run with no spaces
 * would otherwise push the card past the dialog. */
.name {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: var(--fs-exercise);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-snug);
  letter-spacing: var(--ls-heading);
  overflow-wrap: anywhere;
  color: var(--text);
}

.figures,
.when {
  font-variant-numeric: tabular-nums;
  line-height: var(--lh-note);
  color: var(--text-2);
}

.figures {
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
}

.when {
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
}

/* The first save may already have reached the server. The words carry it; it is set in the body
 * ink rather than the card's quiet tier so it is not mistaken for another figure. */
.warning {
  margin-top: var(--space-1);
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text);
}

/* The price of deleting the leftover plan, stated before it is paid — one line under the card, on
 * both prompts. The button that pays it names this line through `aria-describedby`. */
.priceNote {
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}
